import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ExploreFreeToolsButton = ({
  trackingSource,
  use,
  block
}) => {
  const onClick = () => {
    trackClickedLink({
      url: '/crm',
      type: 'internal',
      value: getI18nText('pricingPage.pricingCtas.exploreFreeTools', {
        locale: 'en-us'
      }),
      trackingSource
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    use: use,
    href: "/crm",
    onClick: onClick,
    block: block,
    margin: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.exploreFreeTools"
    })
  });
};
export default ExploreFreeToolsButton;